/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Reviewers_Groups_LabelInputs */



/**
* | output |
* | --- |
* | "Reviewers (groups)" |
*
* @param {Iconik_Publish_Reviewers_Groups_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_reviewers_groups_label = /** @type {((inputs?: Iconik_Publish_Reviewers_Groups_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Reviewers_Groups_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reviewers (groups)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Reviewers (groups)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reviewers (groups)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Reviewers (groups)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reviewers (groups)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Reviewers (groups)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Reviewers (groups)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Reviewers (groups)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reviewers (groups)")
	return /** @type {LocalizedString} */ ("Reviewers (groups)")
});